import React from 'react';

export default function Home() {
  return (
    <>
      {' '}
      <main>
        <h2>Welcome to Math magicians</h2>
        <p>
          Math magicians is a website for all fans of mathematics. It is a
          Single Page App (SPA) that allows users to: Make simple calculations.
          Read a random math-related quote
        </p>
        <p>
          A calculator is an app that provides arithmetic capabilities. The most
          basic calculators, which can cost pennies to purchase, add, subtract,
          multiply and divide. More advanced devices handle sines, cosines and
          other trigonometric functions. Whether mechanical or electronic, all
          calculators accept numeric input from dials, levers or a keypad. The
          results are displayed as mechanical digits, on punched paper tape or
          on a screen, such as an LCD. Unlike computers, calculators perform a
          finite set of functions, and they cannot handle text.
        </p>
      </main>
    </>
  );
}
